import { render } from "./AppNavbarActions.vue?vue&type=template&id=64bcb270"
import script from "./AppNavbarActions.vue?vue&type=script&lang=js"
export * from "./AppNavbarActions.vue?vue&type=script&lang=js"

import "./AppNavbarActions.vue?vue&type=style&index=0&id=64bcb270&lang=scss"
script.render = render

export default script